import React from "react";
import BackButton from "src/components/BackButton";

interface UserTabProps {
  setTab: React.Dispatch<React.SetStateAction<number>>;
  tab: number;
}

const UserTab: React.FC<UserTabProps> = ({ setTab, tab }) => {
  return (
    <div className="flex gap-4 border-b-2 border-gray-200 px-2 sm:px-0 overflow-x-auto">
      <BackButton />

      <button
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap ${
          tab === 0
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
        onClick={() => setTab(0)}
      >
        User Details
      </button>

      <button
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap ${
          tab === 1
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
        onClick={() => setTab(1)}
      >
        Order History
      </button>

      <button
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap ${
          tab === 2
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
        onClick={() => setTab(2)}
      >
        Wallet History
      </button>

      <button
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap ${
          tab === 3
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
        onClick={() => setTab(3)}
      >
        Transaction History
      </button>
    </div>
  );
};

export default UserTab;
